import * as mediaActions from 'modules/medias/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const addMediaToDelete = (state, { payload }) => ([...state, payload.mediaId]);
const removeMediaToDelete = (state, { payload }) => state.filter(mediaId => mediaId !== payload.mediaId);

export default createReducer(initialState, {
  [mediaActions.DELETE_MEDIA]: addMediaToDelete,
  [mediaActions.DELETE_MEDIA_SUCCESS]: removeMediaToDelete,

  [LOCATION_CHANGE]: () => initialState,
});
